import { useNavigate } from "react-router-dom";
import type { PlanStepView, PlayRequest } from "../lib/types";

const VERB = { lesson: "Learn", drill: "Drill", trial: "Trial", mixed: "Practice" } as const;

/** Today's coached steps. Each one does the thing when tapped; done steps are ticked. */
export function CoachPlan({ plan }: { plan: PlanStepView[] }) {
  const nav = useNavigate();
  const go = (s: PlanStepView) => {
    if (s.kind === "lesson") return nav(`/learn/${s.lesson}`);
    const req: PlayRequest = s.kind === "drill" ? { mode: "drill", skill: s.skill, level: s.level, length: 10 }
      : s.kind === "trial" ? { mode: "drill", skill: s.skill, trial: true } : { mode: "adaptive", length: 10 };
    nav("/play", { state: req });
  };
  return <ol className="plan">
    {plan.map((s) => <li key={s.id} className={s.done ? "done" : ""}>
      <span className={"tick" + (s.done ? " on" : "")} aria-hidden="true">{s.done ? "✓" : ""}</span>
      <div><b>{s.title}</b><div className="small mute">{s.why}</div></div>
      <button className="btn ink" disabled={s.done} onClick={() => go(s)} aria-label={`${VERB[s.kind]}: ${s.title}`}>{s.done ? "Done" : VERB[s.kind]}</button>
    </li>)}
  </ol>;
}
